export default () => {
  const staffInjuredMessage = $(".staff_injured_message");
  const staffInjuredCheckbox = $("#incident_report_incident_is_security_incident_types_3");

  const toggleStaffInjuredMessage = (isChecked) => {
    staffInjuredMessage.toggle(isChecked);
  };
  toggleStaffInjuredMessage(staffInjuredCheckbox.prop("checked"));

  staffInjuredCheckbox.on("change", function () {
    toggleStaffInjuredMessage(this.checked);
  });
};
